<template>
  <div class="about">
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-container grid-list-lg>
        <span>Privacy Policy</span>
        <v-alert :type="type_information" variant="tonal">
          {{ policy }}
        </v-alert>
      </v-container>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({
    type_information: "",
    policy: "",
  }),
  created() {
    this.axios
      .get("/information")
      .then((response) => {
        this.type_information = response.data.data_type;
        this.policy = response.data.data_policy;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });
  },
};
</script>
